import { Box, Typography, Container, Button, Divider } from "@mui/material";
import Image from "next/image";
import "../app/globals.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next"; // ← ADD

const FooterWithCTA = () => {
  const { t, i18n } = useTranslation(); // ← ADD
  const isArabic = i18n.language === "ar"; // ← ADD

  return (
    <Box
      sx={{
        backgroundColor: "#1a1d2e",
        color: "white",
        py: { xs: 5, sm: 6, md: 6 },
        mt: "-3%",
        direction: isArabic ? "rtl" : "ltr", // ← ADD
      }}
    >
      <Container maxWidth="lg">
        {/* Logo and Description */}
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 3,
              mt: "-1%",
              justifyContent: {
                xs: "flex-start",
                sm: "flex-start",
                md: "flex-start",
                lg: "flex-start",
              },
            }}
          >
            <Image
              src="https://getgeek-website-assets.b-cdn.net/Getgeek%20Images/GETGEEK_LOGO_WHITE.webp"
              alt="Getgeek"
              width={140}
              height={50}
              style={{
                width: "auto",
                height: "auto",
              }}
            />
          </Box>

          <Typography
            variant="h2"
            component="h2"
            sx={{
              color: "#9CA3AF",
              fontSize: { xs: "0.85rem", sm: "0.9rem", md: "0.9rem" },
              fontFamily: "var(--font-outfit)",
              fontWeight: 400,
              mt: isArabic ? "1%" : "-.7%",
              textAlign: isArabic ? "right" : "left",
            }}
          >
            {t("blogFooterSimple.description")} {/* ← REPLACE */}
          </Typography>
        </Box>

        <Divider
          sx={{
            borderColor: "#767980ff",
            mt: "2.5%",
          }}
        />

        {/* Copyright */}
        <Typography
          sx={{
            mb: "-1.5%",
            mt: "3%",
            color: "#9CA3AF",
            fontSize: { xs: "0.85rem", sm: "0.9rem" },
            fontFamily: "var(--font-outfit)",
            fontWeight: 400,
            textAlign: isArabic ? "right" : "left",
          }}
        >
          {t("blogFooterSimple.copyright")} {/* ← REPLACE */}
        </Typography>
      </Container>
    </Box>
  );
};

export default FooterWithCTA;
